/** @jsxImportSource @emotion/react */
import { MenuSection } from "../../../common/context/SharedFormTypes"
import { getMuiIconElement } from "./MenuIconPicker"
import { SectionCard } from "./SectionCard"

interface MenuSectionCardProps {
    section: MenuSection
    primaryColor: string
    onClick: () => void
    onDelete: () => void
}

export const MenuSectionCard = ({ section, primaryColor, onClick, onDelete }: MenuSectionCardProps) => {
    const icon = section.iconType === 'emoji'
        ? section.iconValue
        : getMuiIconElement(section.iconValue)

    return (
        <SectionCard
            title={section.title}
            icon={icon}
            isMuiIcon={section.iconType === 'mui'}
            primaryColor={primaryColor}
            onClick={onClick}
            onDelete={onDelete}
        />
    )
}
